<template>
  <div class="dof-card-group">
    <slot></slot>
  </div>
</template>

<script>
import { mixSelectableParent } from '../utils/mix-selectable-parent.js'
export default {
  mixins: [mixSelectableParent('dof-card-group')]
}
</script>

<style scoped>
.dof-card-group {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// index.vue?e0d5643e